// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"68d55f88","453":"63933dbe","455":"caadfefd"}[chunkId] + ".chunk.js";
};